import React, {Component} from 'react';
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class SiteFundTableHeader extends Component
{
  static Layout = [
    { column: "companySiteName", width: 3, name: "Site Name" },
    { column: "town" },
    { column: "postcode" },
    { column: "fund" },
    { column: "fundName", name:"Fund Name" },
    { column: "locationId", name: "Property Reference" },
    { column: "siteStatus", width: 2, name:"Status"},
    { column: "empty", width: 2 }
  ];

  
  render() {
    return (
      
    <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SiteFundTableHeader.Layout}/>)

  }
}